import React, { useEffect, useState } from "react";
import { Input, Select, Switch } from "antd";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";

function StaffShipMainEngineDetails({ id }) {
  const [number_of_main_engine, set_number_of_main_engine] = useState("1");
  const [main_engine_make, set_main_engine_make] = useState("");
  const [main_engine_model, set_main_engine_model] = useState("");
  const [power_rpm_mcr, set_power_rpm_mcr] = useState("");
  const [power_rpm_ncr, set_power_rpm_ncr] = useState("");
  const [no_of_cylinder, set_no_of_cylinder] = useState("");
  const [select_engine_number, set_select_engine_number] = useState("");
  const [mcr_rpm, set_mcr_rpm] = useState("");
  const [ncr_rpm, set_ncr_rpm] = useState("");
  const [checked, setChecked] = useState(false);
  const [epl_mcr, set_epl_mcr] = useState("");
  const [epl_rpm, set_epl_rpm] = useState("");

  const VIEW_API = async (ship_Id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", ship_Id);
      FORM_DATA.append("request_type", "view");
      FORM_DATA.append("main_engine_number", number_of_main_engine);
      post(ApiURL.ship_main_details_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_number_of_main_engine(
            res?.main_engine_data?.number_of_main_engine || select_engine_number
          );
          set_main_engine_make(res?.main_engine_data?.main_engine_make);
          set_main_engine_model(res?.main_engine_data?.main_engine_model);
          set_power_rpm_mcr(res?.main_engine_data?.power_rpm_mcr);
          set_power_rpm_ncr(res?.main_engine_data?.power_rpm_ncr);
          set_no_of_cylinder(res?.main_engine_data?.no_of_cylinder);
          set_mcr_rpm(res?.main_engine_data?.mcr_rpm);
          set_ncr_rpm(res?.main_engine_data?.ncr_rpm);
          setChecked(res?.main_engine_data?.epl_status);
          set_epl_mcr(res?.main_engine_data?.epl_mcr);
          set_epl_rpm(res?.main_engine_data?.epl_rpm);
        }
      });
    } finally {
    }
  };

  useEffect(() => {
    if (select_engine_number) {
      set_main_engine_make("");
      set_main_engine_model("");
      set_power_rpm_mcr("");
      set_power_rpm_ncr("");
      set_no_of_cylinder("");
    }
  }, [select_engine_number]);

  useEffect(() => {
    if (id) {
      VIEW_API(id);
    }
  }, [select_engine_number]);

  return (
    <>
      <h3 style={{ marginTop: "15px" }}>Ship Main Engine Information </h3>
      <div className="row">
        {/* No. of main engine  */}
        <div className="col-6">
          <div className="input-box">
            <label>Number of main engine</label>
            <Select
              // disabled
              value={number_of_main_engine}
              placeholder="--count of main engine --"
              style={{ width: "100%" }}
              onChange={(value) => {
                set_select_engine_number(value);
                set_number_of_main_engine(value);
              }}
            >
              <Select.Option value="1">1</Select.Option>
              <Select.Option value="2">2</Select.Option>
            </Select>
          </div>
        </div>

        {/* main Engine make */}
        <div className="col-6">
          <div className="input-box">
            <label>Main engine make</label>
            <Input
              disabled
              value={main_engine_make}
              placeholder="Main engine make"
              onChange={(e) => set_main_engine_make(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="row">
        {/* Main Engine Model */}
        <div className="col-6">
          <div className="input-box">
            <label>Main engine model</label>
            <Input
              disabled
              value={main_engine_model}
              placeholder="Main engine model"
              onChange={(e) => set_main_engine_model(e.target.value)}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="input-box">
            <label>Number of Cylinder</label>
            <Select
              disabled
              value={no_of_cylinder}
              placeholder="--count of Cylinder --"
              style={{ width: "100%" }}
              onChange={(value) => set_no_of_cylinder(value)}
            >
              {Array.from({ length: 10 }, (_, i) => (
                <Select.Option key={i + 1} value={i + 1}>
                  {i + 1}
                </Select.Option>
              ))}
            </Select>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <div className="input-box">
            <label>MCR Power</label>
            <Input
              disabled
              value={power_rpm_mcr}
              placeholder="MCR Power"
              onChange={(e) => set_power_rpm_mcr(e.target.value)}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="input-box">
            <label>MCR RPM</label>
            <Input
              disabled
              value={mcr_rpm}
              placeholder="MCR RPM"
              onChange={(e) => set_mcr_rpm(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <div className="input-box">
            <label>NCR Power</label>
            <Input
              disabled
              value={power_rpm_ncr}
              placeholder="NCR Power"
              onChange={(e) => set_power_rpm_ncr(e.target.value)}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="input-box">
            <label>NCR RPM</label>
            <Input
              disabled
              value={ncr_rpm}
              placeholder="NCR RPM"
              onChange={(e) => set_ncr_rpm(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="row" style={{ marginLeft: "5px", marginBottom: "5px" }}>
        <div style={{ marginRight: "5px" }}>
          <label>EPL Fitted (Yes / No)</label>
        </div>
        <Switch
          disabled
          value={checked}
          onChange={(checked) => setChecked(checked)}
     checkedChildren="Yes"
          unCheckedChildren="No"
          style={{
            backgroundColor: checked ? "green" : "red",
          }}
        />
      </div>
      {checked && (
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>EPL MCR</label>
              <Input
                disabled
                value={epl_mcr}
                placeholder="EPL MCR"
                onChange={(e) => set_epl_mcr(e.target.value)}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>EPL RPM</label>
              <Input
                disabled
                value={epl_rpm}
                placeholder="EPL RPM"
                onChange={(e) => set_epl_rpm(e.target.value)}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default StaffShipMainEngineDetails;
